import * as visuraSlice from "../visura.slice";
import { useDispatch, useSelector } from "react-redux";
import DragDropZoneRendering from "./dragDropZone";
import { useState, useRef } from "react";

const FIRST_ITEM = 0;
const SECOND_ITEM = 1;

function DragDropZone() {
  const dispatch = useDispatch();
  const status = useSelector(visuraSlice.selectStatus);
  const [dragActive, setDragActive] = useState(false);

  const inputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragActive(false);

    const files = event.dataTransfer.files;
    if (files?.length) {
      uploadFile({ file: files[FIRST_ITEM], dispatch });
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    const files = event.target.files;
    if (files?.length) {
      uploadFile({ file: files[FIRST_ITEM], dispatch });
    }
  };

  const handleButtonClick = () => {
    inputRef.current.click();
  };

  return (
    <DragDropZoneRendering
      onDrag={handleDrag}
      handleDrop={handleDrop}
      onChange={handleChange}
      onButtonClick={handleButtonClick}
      dragActive={dragActive}
      inputRef={inputRef}
      status={status}
    />
  );
}

function uploadFile({ file, dispatch }) {
  dispatch(visuraSlice.setStatus({ status: visuraSlice.Status.UPLOADING }));
  getBase64(file, function (base64) {
    dispatch(visuraSlice.uploadFile({ file: base64, fileName: file.name }));
  });
}

function getBase64(file, callback) {
  console.log(file);
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    const val = reader.result.split("base64,")[SECOND_ITEM];
    callback(val);
  };
  reader.onerror = function (error) {
    console.error("Error: ", error);
  };
}

export default DragDropZone;
